module.exports = __webpack_public_path__ + "img/v04.068781d4.jpg";